import { joinFormatted } from '../../../utils/arrayExtensions';
import { getPluralSuffix } from '../../../utils/plurals';
import { formatNamed } from '../../../utils/stringExtensions';
// Should stay in sync with summaryTextService.mjs

export const summaryTextService = {
  getSummaryText: (summaryData, companyName, totalUnitCount) => {
    const { mostCommonLocations, highestOhts, highestDeviceClasses, yearsInVip } = summaryData;

    const baseText = `${companyName} has ${totalUnitCount} enrolled site(s)`;

    const locationText = summaryTextService.getBaseText(
      ', with the most ({percentage}%) located in {value}',
      mostCommonLocations,
      'percentage',
      'locationName'
    );

    const ohtText = summaryTextService.getBaseText(
      '. The largest percentage of the site(s) ({percentage}%) fall under {value}',
      highestOhts,
      'value',
      'name'
    );

    const deviceClassText = summaryTextService.getBaseText(
      '. The largest percentage of the site(s) ({percentage}%) fall under class of device {value}',
      highestDeviceClasses,
      'value',
      'name'
    );

    const vipText = summaryTextService.getYearsInVip(yearsInVip, companyName);

    return `${baseText}${locationText}${ohtText}${deviceClassText}${vipText}.`;
  },

  getBaseText: (template, value, percentageFieldName, textFieldName) => {
    if (!value?.length) {
      return '';
    }
    const [{ [percentageFieldName]: percentage }] = value;
    const text = joinFormatted(value.map(item => item[textFieldName]));
    return formatNamed(template, { percentage, value: text });
  },

  getYearsInVip: (yearsInVip, companyName) => {
    if (!yearsInVip) {
      return '';
    }
    return `. ${companyName} has been enrolled in VIP for ${yearsInVip} year${getPluralSuffix(
      yearsInVip
    )}`;
  }
};
